export default __webpack_public_path__ + "static/media/ic_copy.3d2b4c6e.svg";